import { gql } from "@apollo/client";
import { SerialNumberNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const SERIAL_NUMBERS_FOR_PRODUCT = gql`
  ${SerialNumberNoNestingFragment}
  query GetSerialNumbersForProduct(
    $productLocationInventoryPricingId: ID!
    $options: SerialNumberListOptions
  ) {
    serialNumbersForProduct(
      productLocationInventoryPricingId: $productLocationInventoryPricingId
      options: $options
    ) {
      items {
        ...SerialNumberNoNesting
      }
    }
  }
`;
